<!-- ################################# -->
<!-- TEMPLATE -->
<!-- ################################# -->
<template>
	<div class="grey-page">
		<section class="container center-horizontal">
			<h3 class="page__main-title">You're now {{title}}</h3>
			<p v-if="demoMode">While in demo mode you won't be able to activate portals and all added properties will be deleted when you activate Live mode.</p>
			<p v-if="demoMode">You are about to activate Live Mode and are taking the first step to becoming the Best Agent! Good for you!</p>
			<p v-if="!demoMode">Congratulations! Your BestAgent account is now live.</p>
			<p v-if="!demoMode">You can now add all of your live properties to BestAgent and activate your portal feeds.</p>
			<p v-if="!demoMode">Once this is done, you will then be able to activate your new free website and, or your GDPR-compliant applicant database function.</p>
			<p v-if="!demoMode">If you get stuck please click on the chat icon at the bottom right of every BestAgent page to chat with our support team.</p>
			<div v-if="!demoMode">
					<button class="mdc-button mdc-button--raised" @click="$router.push('/properties/add')">
						Add Property
					</button>
			</div>
			<div v-else>
				<button class="mdc-button mdc-button--raised" :id="'activate-live'" @click.prevent="toggleDummyMode">
						Activate Live
				</button>
			</div>
		</section>
	</div>
</template>


<!-- ################################# -->
<!-- SCRIPT -->
<!-- ################################# -->
<script>
import api from '@/libs/api.js';

export default {
    data: function() {
        return {
        }
    },
	 computed: {
 		demoMode: function() {
  		  return this.$store.getters.demoMode;
	  },
	  title() {
		  if(this.demoMode) {
			  return 'on Demo Mode';
		  } else {
			  return 'Live';
		  }
	  }
 	},
    methods: {
		 toggleDummyMode: async function() {
			 const newDemoMode = !this.demoMode;

			 const resp = await api({endpoint: this.config.services.companies, path: '/set-demo-mode', method: 'PATCH', body: {demoMode: newDemoMode}});

			 this.$store.commit('setDemoMode', newDemoMode);
		 }
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/Settings-DemoMode.vue